import React from "react";
import styled from "styled-components";
import { colors } from "../theme/colors";

const SectionTitle = ({ children, className, as = "h3", ...props }) => {
  return (
    <StyledSectionTitle className={className} as={as} {...props}>
      {children}
    </StyledSectionTitle>
  );
};

const StyledSectionTitle = styled.h3`
  margin: 0 0 24px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.neutral[800]};
`;

export default SectionTitle;
